<template>
  <el-form-item prop="resolution" class="player-setup-display-resolution">
    <el-radio
      v-for="(resolution, index) in resolutions"
      :key="resolution.label + index"
      v-bind:label="resolution.width + 'x' + resolution.height"
      class="resolution-item inline-block!"
      v-model="model.resolution"
      @change="$emit('change', model.resolution)"
      border>{{ resolution.label }}</el-radio>
    <p class="text-xs input-hint text-center mt-3">{{ $t('playerSetup.DisplayResolutionHint') }}</p>
  </el-form-item>
</template>

<script src="./player-setup-display-resolution.js"></script>
<style lang="scss" src="./player-setup-display-resolution.scss"></style>
